<template>
	<div class="workTaskSteps">
		<div class="stepBox">
			<template>
				<div class="bgCol fourth">
					<div class="item" v-if="detail.is_edit===true">
						<span class="label">任务执行期间有无其它费用支出:</span>
						<div class="input">
							<el-radio-group v-model="is_fee">
								<el-radio :label="1">有支出</el-radio>
								<el-radio :label="2">无支出</el-radio>
							</el-radio-group>
						</div>
					</div>
					<div class="item_btn" v-if="detail.is_edit===true">
						<el-button class="edit_btn" type="primary" plain size="small"
							v-if="is_fee==1 && detail.is_edit===true" @click="addFee()">添加费用情况</el-button>
						<el-button class="edit_btn" type="primary" plain size="small" v-if="is_fee==1"
							@click="openIntro(detail)">填写说明</el-button>
					</div>
					<el-table :data="tableData" class="wx_table" :row-class-name="tableRowClassName">
						<el-table-column prop="money" label="收入/支出">
							<template slot-scope="scope">
								<span v-if="scope.row.type==1">收入</span>
								<span  v-else>支出</span>
							</template>
						</el-table-column>
						<el-table-column prop="type_name" label="费用类别">						
						</el-table-column>
						<el-table-column prop="money" label="费用">
							<template slot-scope="scope">
								{{scope.row.money}}元
							</template>
						</el-table-column>
						<el-table-column prop="remark" label="备注"></el-table-column>
						<el-table-column label="操作" v-if="detail.is_edit==true">
							<template slot-scope="scope">
								<el-button class="edit_btn" type="primary" plain size="small" @click="editFinace(scope.$index)">
									编辑</el-button>
								<el-button class="del_btn" type="warning" plain size="small" @click="deleteFinance(scope.$index)">
									删除</el-button>
							</template>
						</el-table-column>
					</el-table>

					<Last :work_task_id="detail.id" :is_edit="detail.is_edit"
						:task_complete_status="detail.task_complete_status" :content="detail.content"
						:is_weather="is_weather" ref="last"></Last>

				</div>
				<div class="btns" v-if="btnShow && detail.is_edit==true">
					
					<el-button @click="holdShow = true">保存</el-button>
				</div>
			</template>
			<div class="btns">
				<el-button v-if="detail.task_status==200" @click="saveFarmStatus('300')">提交</el-button>
				<!-- <el-button v-if="detail.task_status==300" @click="saveFarmStatus('400')">审核</el-button> -->
				<el-button v-if="detail.task_status==300" @click="handleCheck(detail)">审核</el-button>
			</div>
		</div>
		<!--        批量安排弹窗-->
		<WxMessageBox :show="checkShow" @save="checkSave" @canse="checkCanse">
		    <div slot="content">
				<el-form :model="checkForm" :rules="checkRules" ref="checkForm" label-width="0px">
		        <div class="personnel">
		            <div class="item_label">审核状态:</div>
		            <div class="radio_box">
						
						<el-form-item label="" prop="is_check">
							<el-radio-group v-model="checkForm.is_check">
							    <el-radio :label="1">审核通过</el-radio>
							    <el-radio :label="3">审核拒绝</el-radio>
							  
							  </el-radio-group>
						
						</el-form-item>
		            </div>
		        </div>
				<div class="personnel">
				    <div class="item_label">操作原因:</div>
				    <div class="radio_box">
						
						<el-form-item label="" prop="reason">
							<el-input
							  type="textarea"
							  :rows="2"
							  placeholder="请输入内容"
							  v-model="checkForm.reason">
							</el-input>
						
						</el-form-item>
				    </div>
				</div>
				     </el-form>
		    </div>
		</WxMessageBox>
		<!--        保存弹窗-->
		<WxMessageBox :show="holdShow" @save="holdSave" @canse="holdCanse">
			<div slot="content">
				<div class="word">
					<p>你是否确定保存目前最新的信息！</p>
				</div>
			</div>
		</WxMessageBox>


		<!--        删除弹窗-->
		<WxMessageBox :show="delShow" @save="delsave" @canse="delcanse">
			<div slot="content">
				<div class="word marTop">
					<p>你是否确定删除此项，删除后，</p>
					<p>将不可恢复！</p>
				</div>
			</div>
		</WxMessageBox>

		<!--        添加-->
		<WxMessageBox :show="addShow" @save="addSave" @canse="addCanse">
			<div slot="content">
				<el-form :model="form" :rules="rule" ref="form" label-width="0px">
				<div class="wx_form">
					<div class="form_item">
						<span class="label w110">费用类型:</span>
						<div class="input">
							<el-form-item label="" prop="type">
                                 <el-radio-group v-model="form.type" @change="changeFeeType">
                                    <el-radio :label="1">收入</el-radio>
                                    <el-radio :label="2">支出</el-radio>
                                  </el-radio-group>
								  </el-form-item>
						</div>
					</div>
                  <div class="form_item">
						<span class="label w110">费用选项:</span>
						<div class="input">
							<el-form-item label="" prop="fee_type_id">
                                 <el-select v-model="form.fee_type_id" clearable placeholder="请选择">
                                    <el-option
                                      v-for="item in fee_type_list"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                    </el-option>
                                  </el-select>
								  </el-form-item>
						</div>
					</div>
					<div class="form_item">
						<span class="label w110">费用金额:</span>
							<div class="input">
								<el-form-item label="" prop="money">
					               <el-input placeholder="请输入内容" v-model="form.money" type="number" clearable></el-input>
								</el-form-item>
							</div>
					</div>
					<div class="form_item">
						<span class="label w110">备注:</span>
							<div class="input">
								<el-form-item label="" prop="remark">
					               <el-input placeholder="请输入内容" v-model="form.remark"  type="textarea" style="width: 230px;"></el-input>
								</el-form-item>
							</div>
						</div>					
				</div>
				</el-form>
			</div>
		</WxMessageBox>
	
		
		<el-dialog :visible.sync="dialogIntroVisible">
			 
			 文字说明 :{{intro_text}}
			    <el-divider content-position="right"></el-divider>
			<el-link :href="item" target="_blank" v-for="(item,index) in intro_images_list" v-if="item!=''" :key="index"><img width="100px" height="100px" :src="item" alt="" ></el-link>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getFeeTypeList,
		SaveFarmFinanceTaskFee,
		saveFarmTaskStatus
	} from '@/api/step'
	import Last from '@/components/children/Last';
	import WxMessageBox from '@/components/MessageBox';
	export default {
		name: "financeWorkTaskSteps",
		props: {
			detail: {
				type: Object,
				default: []
			},
			btnShow: {
				type: Boolean,
				default: true
			},
		},
		data() {
			return {
				
				dialogIntroVisible:false,
				intro_images_list:[],
				intro_text:'',
				is_action:1,
				index:0,
				fee_type:1,
				fee_type_list:[],
				is_fee: 1,
				is_weather: 1,
				tableData: [],
                form:{
						 type:1,
						 fee_type_id:'',
						money:'',
						remark:'',
					 },
					rule:{
					type: [{
						required: true,
						message: '必填',
						trigger: 'change'
					}],
					fee_type_id: [{
						required: true,
						message: '必填',
						trigger: 'change'
					}],
				   money: [{
						required: true,
						message: '必填',
						trigger: 'blur'
					}], 
					remark: [{
											required: true,
											message: '必填',
											trigger: 'blur'
										}], 
				},
				delShow: false,
				explain: '',
				holdShow: false,
				addShow: false,
				
				checkShow:false,
				        checkForm:{
				        	       work_task_id:'',
				        	       is_check:'',
								   task_status:400,
				        		   reason:'',
								   type:2,							 
				        },
				        checkRules: {
				        	is_check: [{required: true,message: '请选择审核状态',trigger: 'change'}],
				        	reason: [{required: true,message: '请输入操作原因',trigger: 'blur'}],
																	
				        },
			}
		},
	    created() {
			this.tableData=this.detail.fee_list
	    	 if(this.tableData.length>0){
				 this.is_fee==2
			 }
			 
	    },
		methods: {
			openIntro(detail){
				this.dialogIntroVisible=true
				this.intro_images_list=[]
				this.intro_text=detail.task.finance_remark
				this.intro_images_list=detail.task.finance_images
				
			},
			// 发布弹窗确认
			checkSave(){
				console.log(this.checkForm)
				this.$refs["checkForm"].validate((valid) => {
					if (valid) {	
						saveFarmTaskStatus(this.detail.id, this.checkForm).then(resp => {
							this.$message.success(resp)
							//this.$emit("get_work_task")
							this.$parent.get_work_task();
						}).catch(error => console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			    
			},
			// 发布弹窗取消
			checkCanse(){
			    this.checkShow = false
			},
			handleCheck(row){
				console.log(row)
				this.checkForm.work_task_id=row.id
				//this.checkForm.is_check=row.is_check
				this.checkShow=true
			},
			editFinace(index){
				
				this.tableData.forEach((item,key)=>{
					if(key==index){
						this.form.remark=item.remark
						this.form.fee_type_id=item.id
						this.form.money=item.money
						this.form.type=item.type
						this.get_fee_type_list(item.type)
					}
				})
				this.is_action=2,
				this.index=index
				this.addShow=true
				
			},
			deleteFinance(index){
				this.tableData.forEach((item,key)=>{
					if(key==index){
						this.tableData.splice(item,1)
					}
				})
			},
			changeFeeType(val){
				this.get_fee_type_list(val)
			},
			addFee(){
				this.addShow=true
			
				this.get_fee_type_list(1)
			},
			get_fee_type_list(val){
			getFeeTypeList(val).then(resp=>{
				
				      this.fee_type_list=resp;
			})
			},
			// 表格斑马纹
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex % 2 !== 1) {
					return 'single-row';
				} else {
					return 'double-row';
				}
			},
			// 保存弹窗
			holdSave() {
				if(this.is_fee==1){
					 if(this.tableData.length==0){
						  this.holdShow=false
						 this.$message.error("选择有费用，至少添加一个费用")
						 return false
					 }
				}
				let flag = this.$refs.last.validateForm();
				if (flag) {
					
					 this.$refs.last.form.is_fee=this.is_fee
					 this.$refs.last.form.fee_list=this.tableData
				        
					 SaveFarmFinanceTaskFee(this.detail.id, this.$refs.last.form).then(resp => {
					 	this.$message.success(resp)
				          this.holdShow = false
					 	this.$parent.get_work_task();
					 })
					
				}
				this.holdShow=false
				
			},
			holdCanse() {
				this.holdShow = false
			},

			// 删除弹窗确定
			delsave() {
				this.delShow = false
			},
			// 删除弹窗取消
			delcanse() {
				this.delShow = false
			},

			// 添加
			addSave() {
				this.$refs["form"].validate((valid) => {
					if (valid) {
						   if(this.is_action==1)
						   {
							    this.fee_type_list.forEach((val,key)=>{
									if(this.form["fee_type_id"]==val.id){
										 val.remark=this.form.remark
										 val.money=this.form.money
										 val.type=this.form.type
										 val.fee_type_id=val.id
										  val.type_name=val.name
										this.tableData.push(val)
									}
								})
								}else{
									
									this.tableData.forEach((val,key)=>{
										if(this.index==key){
											val.remark=this.form.remark
											val.money=this.form.money
											val.type=this.form.type
											this.tableData[key]=val
										}
									})
								}
                           this.addShow=false
					} else {
						
						return false;
					}
				});
				
			},
			addCanse() {
				this.addShow = false
			},
			saveFarmStatus(val) {
				let param = {
					task_status: val
				}
				saveFarmTaskStatus(this.detail.id, param).then(resp => {
					this.$message.success(resp)
					//this.$emit("get_work_task")
					this.$parent.get_work_task();
				})
			},
			SaveFarmLastTaskStatus() {
				let flag = this.$refs.last.validateForm();
				if (flag) {
					SaveFarmLastTaskStatus(this.detail.id, this.$refs.last.form).then(resp => {
						this.$message.success(resp)
				         this.holdShow = false
						this.$parent.get_work_task();
					})
				}
			}
		
	},
	components: {
		WxMessageBox,
		Last
	}
	}
</script>

<style lang="less">
	.workTaskSteps {
		.steps {
			padding: 50px 0 35px 0;
			display: flex;
			justify-content: center;
			align-items: center;

			span {
				width: 200px;
				height: 50px;
				line-height: 50px;
				background: transparent;
				text-align: center;
				font-size: 20px;
				font-weight: bold;
				color: #2D99FF;
				position: relative;
				border: 1px solid #2D99FF;
				cursor: pointer;

				&+span {
					margin-left: 59px;
				}

				&:after {
					content: '';
					width: 20px;
					height: 20px;
					background: url("../assets/images/allow_02.png") no-repeat;
					background-size: cover;
					position: absolute;
					right: -40px;
					top: 50%;
					margin-top: -10px;
				}

				&:last-child:after {
					display: none;
				}
			}

			.active {
				color: #fff;
				background: #2D99FF;

				&:after {
					content: '';
					background: url("../assets/images/allow_03.png") no-repeat;
					background-size: cover;
				}
			}
		}

		.stepBox {
			overflow: hidden;

			.btns {
				padding-top: 33px;
				text-align: center;

				.el-button {
					width: 134px;
					height: 40px;
					line-height: 40px;
					border: 1px solid #2D99FF;
					font-size: 18px;
					color: #2D99FF;
					border-radius: 0;
					padding: 0;
					background-color: transparent;
					text-align: center;
				}
			}

			.bgCol {
				padding: 33px 55px;
				background: rgba(45, 153, 255, 0.143);
			}

			.second {
				.item {
					display: flex;
					align-items: center;

					.label {
						width: 315px;
						font-size: 18px;
						color: #fff;
					}

					.el-button {
						width: 120px;
						height: 40px;
						line-height: 40px;
						background: #2D99FF;
						font-size: 18px;
						color: #fff;
						border: 0;
						border-radius: 0;
						padding: 0;
					}

					.el-upload {
						width: 200px;
						height: 180px;
						background: rgba(45, 153, 255, 0.3);
						border-radius: 0;
						border: 0;

						.crop {
							width: 200px;
							height: 180px;
							position: relative;

							&:before {
								content: '';
								width: 70px;
								height: 65px;
								background: url("../assets/images/upLoad_04.png") no-repeat;
								background-size: cover;
								position: absolute;
								top: 50%;
								left: 50%;
								margin-left: -35px;
								margin-top: -32.5px;
								z-index: 1;
							}

							&:after {
								content: '';
								width: 41px;
								height: 41px;
								background: url("../assets/images/upLoad_02.png") no-repeat;
								background-size: cover;
								position: absolute;
								top: 50%;
								left: 50%;
								margin-left: -20.5px;
								margin-top: -20.5px;
								z-index: 2;
							}

							img {
								width: 100%;
							}
						}
					}

					.el-upload-list--picture-card .el-upload-list__item {
						width: 200px;
						height: 180px;
						background: rgba(45, 153, 255, 0.3);
						border-radius: 0;
						border: 0;
					}
				}

				.files {
					align-items: flex-start;
					margin-top: 35px;
				}
			}

			.third {
				.title {
					font-size: 18px;
					color: #fff;
					padding-bottom: 17px;
				}

				.flexBox {
					display: flex;
					flex-wrap: wrap;

					.item {
						display: flex;
						align-items: flex-start;
						margin-top: 27px;
						margin-right: 180px;

						.label {
							width: 65px;
							font-size: 18px;
							color: #D2E9FF;
						}

						.marL {
							margin-left: 45px;
						}

						.wx_uploader {
							width: 90px;
							height: 90px;
							background: rgba(45, 153, 255, 0.3);
							border-radius: 0;
							border: 0;

							.crop {
								width: 90px;
								height: 90px;
								position: relative;

								&:before {
									content: '';
									width: 40px;
									height: 37px;
									background: url("../assets/images/upLoad_03.png") no-repeat;
									background-size: cover;
									position: absolute;
									top: 50%;
									left: 50%;
									margin-left: -20px;
									margin-top: -18.5px;
									z-index: 1;
								}

								&:after {
									content: '';
									width: 30px;
									height: 30px;
									background: url("../assets/images/upLoad_01.png") no-repeat;
									background-size: cover;
									position: absolute;
									top: 50%;
									left: 50%;
									margin-left: -15px;
									margin-top: -15px;
									z-index: 2;
								}

								img {
									width: 100%;
								}
							}
						}
					}
				}
			}

			.fourth {
				position: relative;

				.item {
					width: 100%;
					display: flex;
					align-items: center;
					padding-bottom: 35px;

					.label {
						font-size: 18px;
						color: #FFFFFF;
						padding-right: 72px;
					}

				}

				.item_btn {
					position: absolute;
					right: 55px;
					top: 15px;

					.el-button {
						width: 200px;
						height: 50px;
						line-height: 50px;
						font-size: 18px;
					}
				}

				.wx_table {
					.cell {
						img {
							width: 50px;
							height: 32px;
						}
					}
				}
			}

			.fifth {
				.item {
					display: flex;
					align-items: center;

					.label {
						font-size: 18px;
						color: #FFFFFF;
						padding-right: 72px;
					}
				}
			}

			.sixth {
				.item {
					display: flex;
					align-items: center;
					padding-bottom: 35px;

					.label {
						font-size: 18px;
						color: #FFFFFF;
						width: 320px;
					}
				}

				.wx_table {
					margin-bottom: 35px;
				}

				.explain {
					margin-bottom: 35px;
				}

				.weather {
					width: 150px;
					height: 130px;
					background: rgba(45, 153, 255, 0.3);

					img {
						width: 100%;
					}
				}
			}
		}

		.avatar-uploader {
			width: 70px;
			height: 70px;
			border-radius: 6px;
			border: 1px solid rgba(45, 153, 255, 0.48);
			margin: 0 auto;

			.el-upload {
				width: 70px;
				height: 70px;
			}

			.unloadIcon {
				width: 70px;
				height: 70px;
				position: relative;

				&:after {
					content: '';
					width: 41px;
					height: 41px;
					background: url("../assets/images/upLoad_02.png") no-repeat;
					background-size: cover;
					position: absolute;
					top: 50%;
					left: 50%;
					margin-top: -20.5px;
					margin-left: -20.5px;
				}
			}
		}

		.more-uploader {
			.el-upload--picture-card {
				width: 70px;
				height: 70px;
			}

			.unloadIcon {
				width: 70px;
				height: 70px;
				position: relative;

				&:after {
					content: '';
					width: 41px;
					height: 41px;
					background: url("../assets/images/upLoad_02.png") no-repeat;
					background-size: cover;
					position: absolute;
					top: 50%;
					left: 50%;
					margin-top: -20.5px;
					margin-left: -20.5px;
				}
			}
		}
	}
</style>
